import React from 'react';

import { useFulfillmentPlannerContext } from '../context';

import { DeliveryTime } from './index';

export const FulfillmentPlannerContextDeliveryTimeContainer = ({ className = undefined }) => {
  const { deliveryTime } = useFulfillmentPlannerContext();

  return <DeliveryTime className={className} deliveryTime={deliveryTime} emptyValue='--' />;
};
